import { css } from "@emotion/css";
import { minScreen } from "utils/mediaQueries";
import { Color } from "utils/variables";
import { buttonInteraction } from "utils/mixin";

export const body = css`
  width: 164px;
  position: fixed;
  right: 16px;
  bottom: 22px;
  background: ${Color.White};
  border: 2px solid ${Color.White};
  border-radius: 0 10px 10px 10px;
  box-sizing: border-box;
  font-family: "Hiragino Kaku Gothic Pro";
  z-index: 9999;
  ${minScreen("md")} {
    width: 214px;
  }
`;
export const bodyExpand = css`
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  top: 0;
  left: 0;
  border: none;
  border-radius: 0;
`;

export const expandButton = css(
  buttonInteraction,
  css`
    width: 51px;
    height: 31px;
    position: absolute;
    top: -32px;
    left: -2px;
    background: ${Color.White};
    border-radius: 10px 10px 0 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  `
);
export const expandButtonExpand = css`
  width: 25px;
  height: 25px;
  top: 10px;
  left: 10px;
  background: none;
  border-radius: 0;
  z-index: 20;
`;
export const expandIcon = css`
  fill: ${Color.WarmGrey};
`;
export const shrinkIcon = css`
  fill: ${Color.White};
`;

export const buttonWrap = css`
  padding: 10px 0;
  border-radius: 0 0 10px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const buttonWrapExpand = css`
  width: 100%;
  position: absolute;
  z-index: 10;
  bottom: 0;
  left: 0;
  padding: 10px 20px;
  background: rgba(2, 2, 2, 0.6);
  border-radius: 0;
  box-sizing: border-box;
  justify-content: flex-start;
  ${minScreen("md")} {
    padding: 15px 20px;
  }
`;

export const operateButton = css(
  buttonInteraction,
  css`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  `
);
export const operateButtonExpand = css`
  margin-right: 45px;
  margin-left: 15px;
  padding: 10px 20px;
  background: ${Color.White};
  border-radius: 50px;
  h5 {
    font-size: 14px;
    line-height: 21px;
  }
`;
export const closeIcon = css`
  fill: ${Color.LightBlack};
`;
export const callDownIcon = css`
  fill: ${Color.BrightOrange};
`;
